import axios from "axios";
import { axiosInstance } from "../axiosInstance";
import { configs } from "../config";

export const serviceFetchProductList = (limit: number, offset: number) => {
  let url_path = `${configs.dev_domain_url}/cms/wp-json/wp/v2`;
  const endpoint =
    configs.top_deals_api_endpoint + "?limit=" + limit + "&offset=" + offset;

  if (process.env.REACT_APP_API_URL) {
    url_path = process.env.REACT_APP_API_URL;
  }
  return axiosInstance.post(url_path + endpoint);
};

export const serviceFetchBanners = () => {
  let url_path = `${configs.dev_domain_url}/cms/wp-json/wp/v2`;
  const endpoint = configs.banners_api_endpoint;

  if (process.env.REACT_APP_API_URL) {
    url_path = process.env.REACT_APP_API_URL;
  }
  return axiosInstance.get(url_path + endpoint);
};
export const serviceFetchProductDeals = () => {
  let url_path = `${configs.dev_domain_url}/cms/wp-json/wp/v2`;
  const endpoint = configs.product_deal_api_endpoint;

  if (process.env.REACT_APP_API_URL) {
    url_path = process.env.REACT_APP_API_URL;
  }
  return axiosInstance.get(url_path + endpoint);
};

export const serviceFetchTodaysDeals = () => {
  let url_path = `${configs.dev_domain_url}/cms/wp-json/wp/v2`;
  const endpoint = configs.todays_deal_api_endpoint;

  if (process.env.REACT_APP_API_URL) {
    url_path = process.env.REACT_APP_API_URL;
  }
  return axiosInstance.get(url_path + endpoint);
};

export const serviceFetchBankOffers = () => {
  let url_path = `${configs.dev_domain_url}/cms/wp-json/wp/v2`;
  const endpoint = configs.bank_offers_api_endpoint;

  if (process.env.REACT_APP_API_URL) {
    url_path = process.env.REACT_APP_API_URL;
  }
  return axiosInstance.get(url_path + endpoint);
};


export const serviceFetchSeasonalSales = () => {
  let url_path = `${configs.dev_domain_url}/cms/wp-json/wp/v2`;
  const endpoint = configs.seasonal_sales_api_endpoint;

  if (process.env.REACT_APP_API_URL) {
    url_path = process.env.REACT_APP_API_URL;
  }
  return axiosInstance.get(url_path + endpoint);
};

export const serviceFetchBlogs = () => {
  let url_path = `${configs.dev_domain_url}/cms/wp-json/wp/v2`;
  const endpoint = configs.blogs_api_endpoint;

  if (process.env.REACT_APP_API_URL) {
    url_path = process.env.REACT_APP_API_URL;
  }
  return axiosInstance.get(url_path + endpoint);
};

export const serviceFetchBlogsThumbnail = (id: any) => {
  let url_path = `${configs.dev_domain_url}/cms/wp-json/wp/v2`;
  const endpoint = configs.blog_thumbnail_api_endpoint + id;

  if (process.env.REACT_APP_API_URL) {
    url_path = process.env.REACT_APP_API_URL;
  }
  return axiosInstance.get(url_path + endpoint);
};

export const serviceFetchBlogsUrlPath = (id: any) => {
  let url_path = `${configs.dev_domain_url}/cms/wp-json/wp/v2`;

  if (process.env.REACT_APP_API_URL) {
    url_path = process.env.REACT_APP_API_URL;
  }
  const path =
    url_path +
    configs.blog_posts_api_endpoint +
    id +
    configs.blog_content_api_endpoint;

  return axiosInstance.get(path);
};

//Get blog Post by title
export const serviceFetchBlogsByTitle = (title: any) => {
  let url_path = `${configs.dev_domain_url}/cms/wp-json/wp/v2`;

  if (process.env.REACT_APP_API_URL) {
    url_path = process.env.REACT_APP_API_URL;
  }
  const path =
    url_path + configs.blog_title_search_api_endpoint + title
  return axiosInstance.get(path);
};

export const serviceFetchPages = () => {
  let url_path = `${configs.dev_domain_url}/cms/wp-json/wp/v2`;
  const endpoint = configs.pages_api_endpoint;

  if (process.env.REACT_APP_API_URL) {
    url_path = process.env.REACT_APP_API_URL;
  }
  return axiosInstance.get(url_path + endpoint);
};

export const serviceFetchUserDetails = (user_email_id: string) => {
  let url_path = `${configs.dev_domain_url}/cms/wp-json/wp/v2`;
  const endpoint = configs.user_details_api_endpoint + user_email_id;

  if (process.env.REACT_APP_API_URL) {
    url_path = process.env.REACT_APP_API_URL;
  }
  return axiosInstance.get(url_path + endpoint);
};

export const serviceFetchProductDetails = (id: string) => {
  let url_path = `${configs.dev_domain_url}/cms/wp-json/wp/v2`;
  const endpoint = configs.product_details_api_endpoint + id;

  if (process.env.REACT_APP_API_URL) {
    url_path = process.env.REACT_APP_API_URL;
  }
  return axiosInstance.get(url_path + endpoint);
};

export const serviceFetchSearchUrls = (query_string: string) => {
  let url_path = `${configs.dev_domain_url}/cms/wp-json/wp/v2`;
  const endpoint = configs.product_google_search_api_endpoint;

  if (process.env.REACT_APP_API_URL) {
    url_path = process.env.REACT_APP_API_URL;
  }
  const path = url_path + endpoint;
  const data = {
    search_string: query_string,
  };
  return axiosInstance.post(path, JSON.stringify(data));
};

export const serviceFetchRetailersConfig = () => {
  let url_path = `${configs.dev_domain_url}:5000`;
  const endpoint = configs.retailers_config_api_endpoint;
  // + `?retailer=JIOMART&landing_page=1&query_selector=1`;

  if (process.env.REACT_APP_PRODUCT_SCRAPE_URL) {
    url_path = process.env.REACT_APP_PRODUCT_SCRAPE_URL;
  }
  const path = url_path + endpoint;
  const api_key = ""; // X-Api-Key is injected server-side by the nginx /papi proxy
  return axios.get(path, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const serviceFetchRetailersList = () => {
  let url_path = `${configs.dev_domain_url}:5000`;
  const endpoint = configs.retailer_tag_api_endpoint;

  if (process.env.REACT_APP_PRODUCT_SCRAPE_URL) {
    url_path = process.env.REACT_APP_PRODUCT_SCRAPE_URL;
  }
  const path = url_path + endpoint;
  const api_key = ""; // X-Api-Key is injected server-side by the nginx /papi proxy
  return axios.get(path, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const serviceGetCustomizedTitleParams = () => {
  let url_path = `${configs.dev_domain_url}:5000`;
  const endpoint = configs.get_customized_title_endpoint;
  // + `?retailer=JIOMART&landing_page=1&query_selector=1`;

  if (process.env.REACT_APP_PRODUCT_SCRAPE_URL) {
    url_path = process.env.REACT_APP_PRODUCT_SCRAPE_URL;
  }
  const path = url_path + endpoint;
  const api_key = ""; // X-Api-Key is injected server-side by the nginx /papi proxy
  return {
    path: path,
    api_key: api_key,
  };
};

export const serviceGetBackendAPIParams = () => {
  let url_path = `${configs.dev_domain_url}:5000`;
  const endpoint = configs.product_scrape_data_api_endpoint;
  // + `?retailer=JIOMART&landing_page=1&query_selector=1`;

  if (process.env.REACT_APP_PRODUCT_SCRAPE_URL) {
    url_path = process.env.REACT_APP_PRODUCT_SCRAPE_URL;
  }
  const path = url_path + endpoint;
  const api_key = ""; // X-Api-Key is injected server-side by the nginx /papi proxy
  return {
    path: path,
    api_key: api_key,
  };
};

/* 
export const fetchCromaProductDataFromAPI = async (url: string) => {
  let url_path =
    "http://dev.pricepinger.com:5000";
  const endpoint = configs.product_scrape_api_endpoint;

  if (process.env.REACT_APP_PRODUCT_SCRAPE_URL) {
    url_path = process.env.REACT_APP_PRODUCT_SCRAPE_URL;
  }
  const path = url_path + endpoint;
  const api_key = ""; // X-Api-Key is injected server-side by the nginx /papi proxy
  const data = { url: url };
  return axios.post(path, JSON.stringify(data), {
    headers: {
      "Content-Type": "application/json",
      "X-Api-Key": api_key,
    },
  });
}; */

export const productSaveDataToWPservices = async (product_data: any) => {
  let url_path = `${configs.dev_domain_url}/cms/wp-json/wp/v2`;
  const endpoint = configs.product_save_api_endpoint;

  if (process.env.REACT_APP_API_URL) {
    url_path = process.env.REACT_APP_API_URL;
  }
  const path = url_path + endpoint;

  const data = { ...product_data };
  return axiosInstance.post(path, JSON.stringify(data), {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const fetchProductSuggestionAPIFromWP = async (querystring: string) => {
  let url_path = `${configs.dev_domain_url}/cms/wp-json/wp/v2`;
  const endpoint = configs.product_search_api_endpoint;

  if (process.env.REACT_APP_API_URL) {
    url_path = process.env.REACT_APP_API_URL;
  }
  const path = url_path + endpoint;

  const data = { search_string: querystring };
  return axiosInstance.post(path, JSON.stringify(data), {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const fetchProductSuggestionAPIWithFilterFromWP = async (
  querystring: string,
  filterArray: any,
  limit: number,
  offset: number
) => {
  let url_path = `${configs.dev_domain_url}/cms/wp-json/wp/v2`;
  const endpoint =
    configs.product_search_api_endpoint + `?limit=${limit}&offset=${offset}`;

  if (process.env.REACT_APP_API_URL) {
    url_path = process.env.REACT_APP_API_URL;
  }
  const path = url_path + endpoint;

  const data = {
    search_string: querystring,
    brands: filterArray.brand,
    retailers: filterArray.retailers,
    discounts: filterArray.discount,
  };
  return axiosInstance.post(path, JSON.stringify(data), {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const fetchProductAPIWithFilterFromWP = async (
  filterArray: any,
  limit: number,
  offset: number
) => {
  let url_path = `${configs.dev_domain_url}/cms/wp-json/wp/v2`;
  const endpoint =
    configs.top_deals_api_endpoint + `?limit=${limit}&offset=${offset}`;

  if (process.env.REACT_APP_API_URL) {
    url_path = process.env.REACT_APP_API_URL;
  }
  const path = url_path + endpoint;

  const data = {
    brands: filterArray.brand,
    retailers: filterArray.retailers,
    discounts: filterArray.discount,
  };
  return axiosInstance.post(path, JSON.stringify(data), {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const serviceGETCountryCode = async (): Promise<string | null> => {
  try {
    const path = configs.get_country_code_api_endpoint;
    const response = await axios.get(path, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response?.data?.postal;
  } catch (error) {
    console.error("Error fetching postal code:", error);
    return null;
  }
};

export const serviceFetchRetailerLogo = () => {
  let url_path = `${configs.dev_domain_url}/cms/wp-json/wp/v2`;
  const endpoint = configs.retailer_logo_api_endpoint;

  if (process.env.REACT_APP_API_URL) {
    url_path = process.env.REACT_APP_API_URL;
  }
  return axiosInstance.get(url_path + endpoint);
};